﻿import { HtmlContentEditor, Widget } from "@serenity-is/corelib";
import { Config, ErrorHandling, notifySuccess, confirmDialog } from "@serenity-is/corelib/q";
import { SystemAdminService } from "@/ServerTypes/SystemAdmin";


Config.responsiveDialogs = true;
Config.rootNamespaces.push( "Recon.Spotlight" );
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";

  if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
  }

window.onerror = ErrorHandling.runtimeErrorHandler;

//
// A wrapper for the clear cach button
export class ResetAllCachesButton extends Widget<any> {

  protected btn;

  constructor(element: JQuery, options: any) {
    super(element);
    element.click((e) => this.HandleClick(e, options));
  }

  HandleClick(e: JQueryEventObject, options: any) {
    console.log( "HandleClick" );
    SystemAdminService.ResetCache(null, response => {
      if (!response.Error) {
        notifySuccess("All caches have been reset");
      }
    })
  }
}

export class ResetHealthDashboardCacheButton extends Widget<any> {

  constructor(element: JQuery, options: any) {
    super(element);
    element.click((e) => this.HandleClick(e, options));
  }

  HandleClick(e: JQueryEventObject, options: any) {
    confirmDialog("Are you sure you want to reset the Health Dashboard cache for the current client?", () => {
      SystemAdminService.ResetCurrentClientHealthDashboardCache({}, response => {
        if (!response.Error) {
          notifySuccess("Health Dashboard cache has been reset for the current client");
        }
      });
    });
  }
}

// Attach the class to the link
$( (_) => {
  new ResetAllCachesButton( $( ".x-dev-reset-all-caches" ), {} ).init();
  new ResetHealthDashboardCacheButton( $( ".x-dev-reset-health-dashboard-cache" ), {} ).init();
} );
